import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import { GripVertical } from 'lucide-react';
import styles from './Payments.module.scss';

interface SortableRowProps {
  /** Unique within its SortableContext. */
  id: string;
  children: React.ReactNode;
}

/** A table row whose first cell is a drag handle. */
const SortableRow: React.FC<SortableRowProps> = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });
  return (
    <tr
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      className={isDragging ? styles.dragging : ''}
    >
      <td>
        <Box
          {...attributes}
          {...listeners}
          className={styles.dragHandle}
          aria-label="Drag to reorder"
        >
          <GripVertical size={20} />
        </Box>
      </td>
      {children}
    </tr>
  );
};

export default SortableRow;
